<template>
	<div class="user">
		<h2 class="tit-30 fw700">个人资料</h2>

		<div class="list">
			<div class="item flex-sbcw">
				<div class="left flex-c">
					<div class="imgBox flex-cc">
						<el-image :src="require('@/assets/logo2.png')" fit="contain"></el-image>
					</div>
					<div class="name ml-20 fw700 flex-c">
						<div class="tel mr-10">{{yonghu.zhanghao | mobileFilter}}</div>
						<div class="tip tit-12" v-if="shenghezhuangtai==0 || shenghezhuangtai==1">个人账户</div>
						<div class="tip tit-12" v-if="shenghezhuangtai==3 || shenghezhuangtai==4">企业账户未认证</div>
						<div class="tip tit-12" v-if="shenghezhuangtai==2">企业账户</div>
					</div>
				</div>
				<div class="right p2 tit-14 cur_pointer" @click="$router.push('/companyAuth')"
					v-if="shenghezhuangtai==0 || shenghezhuangtai==3">
					<span v-if="shenghezhuangtai==0">升级为企业用户</span>
					<span v-if="shenghezhuangtai==3">提交企业认证信息</span>
					<i class="el-icon-arrow-right"></i>
				</div>
				<div class="right p2 tit-14" v-else>
					<span v-if="shenghezhuangtai==1 || shenghezhuangtai==4">审核中</span>
					<span v-if="shenghezhuangtai==2">已审核</span>
					<i class="el-icon-arrow-right"></i>
				</div>

			</div>

			<div class="item flex-sbc">
				<div class="p1">登录安全</div>
				<div class="p2 tit-14" @click="$router.push('/forgetPwd')">
					修改密码 <i class="el-icon-arrow-right"></i>
				</div>
			</div>

			<div class="item flex-sbc">
				<div class="p1">手机号</div>
				<div class="p2 tit-14">
					{{yonghu.zhanghao | mobileFilter}}<i class="el-icon-arrow-right"></i>
				</div>
			</div>
		</div>
	</div>
</template>
<script>
	let that
	export default {
		name: "OrderIndex",
		data() {
			return {
				yonghu: {},
				shu: {},
				shenghezhuangtai:0
			};
		},
		filters: {
			mobileFilter(val) {
				let reg = /^(.{3}).*(.{4})$/
				return val.replace(reg, '$1****$2')
			}
		},
		created() {
			that = this
			// console.log(this.$qu('renzhen'), 'renzhen')
			if (that.$qu('yonghux')['id']) {
				that.yonghu = that.$qu('yonghux')
				that.$post("m=limitao&k=huiyuan",function(s) {
						if (s.shi == 1) {
							if (s.shu.leixing == 0 && s.shu.renzhenzhuangtai == 0) {
								that.shenghezhuangtai = 0;
							} else if (s.shu.leixing == 0 && s.shu.renzhenzhuangtai == 1) {
								that.shenghezhuangtai = 1;
							} else if (s.shu.leixing == 1 && s.shu.renzhenzhuangtai == 0) {
								that.shenghezhuangtai = 3;
							} else if (s.shu.leixing == 1 && s.shu.renzhenzhuangtai == 2) {
								that.shenghezhuangtai = 2;
							} else if (s.shu.leixing == 1 && s.shu.renzhenzhuangtai == 1) {
								that.shenghezhuangtai = 4;
							}
						}
				})
			} else {
				that.yonghu = {}
				that.$xiaoxi('请先登录')
				setTimeout(() => {
					that.$dakai('/');
				}, 1000);
			}
		},
		computed: {},
		methods: {},
	};
</script>
<style lang="less" scoped>
	.user {
		.list {
			margin-top: 0.3rem;

			.item {
				padding: 0.24rem 0;
				border-bottom: 1px solid #f9f9f9;

				.left {
					.imgBox {
						width: 0.6rem;
						height: 0.6rem;
						border-radius: 50%;
						overflow: hidden;
						background: #f9f9f9;

						.el-image {
							max-width: 45%;
							display: flex;
						}
					}

					.name {
						.tip {
							align-items: center;
							color: #fff;
							background: linear-gradient(to right, #44d2ff 0%, #001ff5 100%);
							padding: 3px 6px;
							border-radius: 3px;
						}
					}
				}

				.p2 {
					color: #1478fe;
				}
			}
		}
	}
</style>